import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import { useSelector } from "react-redux";
const Department = (props) => {
  const { t } = useTranslation();
  const language = useSelector((state)=> state.languages?.data)

  const [attributes] = useState(() => {
      const baseAttributes = [
        {
          type: "text",
          placeholder: "de",
          name: "de",
          validation: "",
          default: "",
          label: "de",
          required: true,
          view: true,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "en",
          name: "en",
          validation: "",
          default: "",
          label: "en",
          required: true,
          view: true,
          add: true,
          update: true,
        }
      ];
  
      language.length >0 && language?.filter((val)=> val?.id?.toLowerCase()!=="de" && val?.id?.toLowerCase()!=="en")?.map((item)=>{
        baseAttributes.push({
          type: "text",
          placeholder: item.id?.toLowerCase(),
          name: item.id?.toLowerCase(),
          validation: "",
          default: "",
          label: item.id?.toLowerCase(),
          required: false,
          view: true,
          add: true,
          update: true,
        })
      })
  
      baseAttributes.push({
        type: "checkbox",
        placeholder: "active",
        name: "isActive",
        validation: "",
        showItem: "",
        default: "true",
        label: "active",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
        filter: false,
      })
  
    
      // If the user's role is "super", add the "en" object to the array
      // if (user.data?.user?.role === "super") {
      //   baseAttributes.unshift({
      //     type: "text",
      //     placeholder: "en",
      //     name: "en",
      //     validation: "",
      //     default: "",
      //     label: "en",
      //     required: true,
      //     view: true,
      //     add: true,
      //     update: true,
      //   });
      // }
    
      return baseAttributes;
    });

  //to update the page title
  useEffect(() => {
    document.title = `${t("faq-category")} - Whistleblowing24`;
  }, [t]);

  return (
    <Container className="noshadow">
      <ListTable {...props} actions={[]} viewDetails={false} api={`faq-category`} itemTitle={sessionStorage.getItem("_lang") ?? "de"} shortName={`faq-category`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes} ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Department);
